import { atom } from 'jotai';

export const siteFilterAtom = atom([
  
]);